import { render, staticRenderFns } from "./ExamsTeacher.vue?vue&type=template&id=3f66f2aa&"
import script from "./ExamsTeacher.vue?vue&type=script&lang=js&"
export * from "./ExamsTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports